import HttpService from "./htttp.service";

class OrdersService {
  // OrdersEndpoint = process.env.API_URL;

  getOrders = async () => {
    const getOrders = "dash/orders";
    return await HttpService.get(getOrders);
  };

  getOrdersStats = async () => {
    const getOrdersStats = "dash/orders/stats";
    return await HttpService.get(getOrdersStats);
  };

  getIncompleteOrders = async () => {
    const getIncompleteOrders = "dash/orders/incomplete";
    return await HttpService.get(getIncompleteOrders);
  };

  getSingleOrder = async (id) => {
    const getSingleOrder = `dash/orders/${id}`;
    return await HttpService.get(getSingleOrder);
  };

  createNewOrder = async (order) => {
    const createNewOrder = "dash/orders/new";
    return await HttpService.post(createNewOrder, order);
  };

  editOrder = async (id, order) => {
    const editOrder = `dash/orders/${id}`;
    return await HttpService.put(editOrder, order);
  };
}

export default new OrdersService();
